import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
    _excluded2 = ["show", "appear", "unmount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import d, { Fragment as K, createContext as Q, useContext as J, useEffect as P, useMemo as Y, useRef as f, useState as X } from "react";
import { Features as de, forwardRefWithAs as W, render as Z, RenderStrategy as E } from '../../utils/render.js';
import { OpenClosedProvider as fe, State as b, useOpenClosed as $ } from '../../internal/open-closed.js';
import { match as D } from '../../utils/match.js';
import { useIsMounted as pe } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as me } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as V } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as ee } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as te } from '../../hooks/use-sync-refs.js';
import { useTransition as ce } from '../../hooks/use-transition.js';
import { useEvent as R } from '../../hooks/use-event.js';
import { useDisposables as he } from '../../hooks/use-disposables.js';
import { classNames as ve } from '../../utils/class-names.js';
import { env as ge } from '../../utils/env.js';
import { useFlags as Ce } from '../../hooks/use-flags.js';

function S() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return n.split(" ").filter(function (t) {
    return t.trim().length > 1;
  });
}

var A = Q(null);
A.displayName = "TransitionContext";

var Ee = function (r) {
  return r.Visible = "visible", r.Hidden = "hidden", r;
}(Ee || {});

function be() {
  var n = J(A);
  if (n === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return n;
}

function Se() {
  var n = J(I);
  if (n === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return n;
}

var I = Q(null);
I.displayName = "NestingContext";

function _(n) {
  return "children" in n ? _(n.children) : n.current.filter(function (_ref) {
    var t = _ref.el;
    return t.current !== null;
  }).filter(function (_ref2) {
    var t = _ref2.state;
    return t === "visible";
  }).length > 0;
}

function ne(n, t) {
  var r = V(n),
      o = f([]),
      y = pe(),
      N = he(),
      p = R(function (s) {
    var _D;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : E.Hidden;
    var a = o.current.findIndex(function (_ref3) {
      var i = _ref3.el;
      return i === s;
    });
    a !== -1 && (D(e, (_D = {}, _defineProperty(_D, E.Unmount, function () {
      o.current.splice(a, 1);
    }), _defineProperty(_D, E.Hidden, function () {
      o.current[a].state = "hidden";
    }), _D)), N.microTask(function () {
      var i;
      !_(o) && y.current && ((i = r.current) == null || i.call(r));
    }));
  }),
      x = R(function (s) {
    var e = o.current.find(function (_ref4) {
      var a = _ref4.el;
      return a === s;
    });
    return e ? e.state !== "visible" && (e.state = "visible") : o.current.push({
      el: s,
      state: "visible"
    }), function () {
      return p(s, E.Unmount);
    };
  }),
      m = f([]),
      c = f(Promise.resolve()),
      u = f({
    enter: [],
    leave: [],
    idle: []
  }),
      h = R(function (s, e, a) {
    m.current.splice(0), t && (t.chains.current[e] = t.chains.current[e].filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          i = _ref6[0];

      return i !== s;
    })), t == null || t.chains.current[e].push([s, new Promise(function (i) {
      m.current.push(i);
    })]), t == null || t.chains.current[e].push([s, new Promise(function (i) {
      Promise.all(u.current[e].map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            l = _ref8[0],
            T = _ref8[1];

        return T;
      })).then(function () {
        return i();
      });
    })]), e === "enter" ? c.current = c.current.then(function () {
      return t == null ? void 0 : t.wait.current;
    }).then(function () {
      return a(e);
    }) : a(e);
  }),
      v = R(function (s, e, a) {
    Promise.all(u.current[e].splice(0).map(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          i = _ref10[0],
          l = _ref10[1];

      return l;
    })).then(function () {
      var i;
      (i = m.current.shift()) == null || i();
    }).then(function () {
      return a(e);
    });
  });
  return Y(function () {
    return {
      children: o,
      register: x,
      unregister: p,
      onStart: h,
      onStop: v,
      wait: c,
      chains: u
    };
  }, [x, p, o, h, v, u, c]);
}

function xe() {}

var Pe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];

function re(n) {
  var r;
  var t = {};

  var _iterator = _createForOfIteratorHelper(Pe),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var o = _step.value;
      t[o] = (r = n[o]) != null ? r : xe;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t;
}

function Re(n) {
  var t = f(re(n));
  return P(function () {
    t.current = re(n);
  }, [n]), t;
}

var ye = "div",
    ie = de.RenderStrategy;

function Ne(n, t) {
  var _D3;

  var r = n.beforeEnter,
      o = n.afterEnter,
      y = n.beforeLeave,
      N = n.afterLeave,
      p = n.enter,
      x = n.enterFrom,
      m = n.enterTo,
      c = n.entered,
      u = n.leave,
      h = n.leaveFrom,
      v = n.leaveTo,
      s = _objectWithoutProperties(n, _excluded),
      e = f(null),
      a = te(e, t),
      i = s.unmount ? E.Unmount : E.Hidden,
      _be = be(),
      l = _be.show,
      T = _be.appear,
      se = _be.initial,
      _X = X(l ? "visible" : "hidden"),
      _X2 = _slicedToArray(_X, 2),
      g = _X2[0],
      M = _X2[1],
      z = Se(),
      F = z.register,
      L = z.unregister,
      U = f(null);

  P(function () {
    return F(e);
  }, [F, e]), P(function () {
    if (i === E.Hidden && e.current) {
      var _D2;

      if (l && g !== "visible") {
        M("visible");
        return;
      }

      return D(g, (_D2 = {}, _defineProperty(_D2, "hidden", function hidden() {
        return L(e);
      }), _defineProperty(_D2, "visible", function visible() {
        return F(e);
      }), _D2));
    }
  }, [g, e, F, L, l, i]);
  var j = V({
    enter: S(p),
    enterFrom: S(x),
    enterTo: S(m),
    entered: S(c),
    leave: S(u),
    leaveFrom: S(h),
    leaveTo: S(v)
  }),
      w = Re({
    beforeEnter: r,
    afterEnter: o,
    beforeLeave: y,
    afterLeave: N
  }),
      k = ee();
  P(function () {
    if (k && g === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e, g, k]);

  var G = se && !T,
      ae = function () {
    return !k || G || U.current === l ? "idle" : l ? "enter" : "leave";
  }(),
      H = Ce(0),
      le = R(function (C) {
    return D(C, {
      enter: function enter() {
        H.addFlag(b.Opening), w.current.beforeEnter();
      },
      leave: function leave() {
        H.addFlag(b.Closing), w.current.beforeLeave();
      },
      idle: function idle() {}
    });
  }),
      ue = R(function (C) {
    return D(C, {
      enter: function enter() {
        H.removeFlag(b.Opening), w.current.afterEnter();
      },
      leave: function leave() {
        H.removeFlag(b.Closing), w.current.afterLeave();
      },
      idle: function idle() {}
    });
  }),
      O = ne(function () {
    M("hidden"), L(e);
  }, z);

  ce({
    container: e,
    classes: j,
    direction: ae,
    onStart: V(function (C) {
      O.onStart(e, C, le);
    }),
    onStop: V(function (C) {
      O.onStop(e, C, ue), C === "leave" && !_(O) && (M("hidden"), L(e));
    })
  }), P(function () {
    G && (i === E.Hidden ? U.current = null : U.current = l);
  }, [l, G, g]);
  var B = s,
      Te = {
    ref: a
  };
  return T && l && ge.isServer && (B = _objectSpread(_objectSpread({}, B), {}, {
    className: ve.apply(void 0, [s.className].concat(_toConsumableArray(j.current.enter), _toConsumableArray(j.current.enterFrom)))
  })), d.createElement(I.Provider, {
    value: O
  }, d.createElement(fe, {
    value: D(g, (_D3 = {}, _defineProperty(_D3, "visible", b.Open), _defineProperty(_D3, "hidden", b.Closed), _D3)) | H.flags
  }, Z({
    ourProps: Te,
    theirProps: B,
    defaultTag: ye,
    features: ie,
    visible: g === "visible",
    name: "Transition.Child"
  })));
}

function He(n, t) {
  var r = n.show,
      _n$appear = n.appear,
      o = _n$appear === void 0 ? !1 : _n$appear,
      y = n.unmount,
      N = _objectWithoutProperties(n, _excluded2),
      p = f(null),
      x = te(p, t);

  ee();
  var m = $();
  if (r === void 0 && m !== null && (r = (m & b.Open) === b.Open), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");

  var _X3 = X(r ? "visible" : "hidden"),
      _X4 = _slicedToArray(_X3, 2),
      c = _X4[0],
      u = _X4[1],
      h = ne(function () {
    u("hidden");
  }),
      _X5 = X(!0),
      _X6 = _slicedToArray(_X5, 2),
      v = _X6[0],
      s = _X6[1],
      e = f([r]);

  me(function () {
    v !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), s(!1));
  }, [e, r]);
  var a = Y(function () {
    return {
      show: r,
      appear: o,
      initial: v
    };
  }, [r, o, v]);
  P(function () {
    if (r) u("visible");else if (!_(h)) u("hidden");else {
      var l = p.current;
      if (!l) return;
      var T = l.getBoundingClientRect();
      T.x === 0 && T.y === 0 && T.width === 0 && T.height === 0 && u("hidden");
    }
  }, [r, h]);
  var i = {
    unmount: y
  };
  return d.createElement(I.Provider, {
    value: h
  }, d.createElement(A.Provider, {
    value: a
  }, Z({
    ourProps: _objectSpread(_objectSpread({}, i), {}, {
      as: K,
      children: d.createElement(oe, _objectSpread(_objectSpread({
        ref: x
      }, i), N))
    }),
    theirProps: {},
    defaultTag: K,
    features: ie,
    visible: c === "visible",
    name: "Transition"
  })));
}

function De(n, t) {
  var r = J(A) !== null,
      o = $() !== null;
  return d.createElement(d.Fragment, null, !r && o ? d.createElement(q, _objectSpread({
    ref: t
  }, n)) : d.createElement(oe, _objectSpread({
    ref: t
  }, n)));
}

var q = W(He),
    oe = W(Ne),
    Fe = W(De),
    tt = Object.assign(q, {
  Child: Fe,
  Root: q
});
export { tt as Transition };